import React from "react";
// import logo from './logo.svg';
import "./GreenButton.scss";

const GreenButton = (props) => {
  return (
    <>
      <button
        disabled={props.disabled}
        onClick={props.onClick}
        // style={{ ...props.style, opacity: props.disabled ? 1 : 1 }}
        className="play-button"
      >
        {" "}
        {props.children}
      </button>
    </>
  );
};
export default GreenButton;
